import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Calendar from "../../../../../../../components/calendar/Calendar";
import Autocomplete from "../../../../../../../components/autocomplete/Autocomplete";
import SelectAutocomplete from "../../../../../../../components/selectAutocomplete/SelectAutocomplete";
import Utils from "../../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json";
import styles from "../SchedaSpecialeArbovirosi.module.css";
class DatiSegnalazione extends Component {
    state = {
        datiSegnalazione: {
            dataSegnalazione: "",
            regione: "",
            ulss: "",
            corretto: []
        },
        regioni: [],
        listaUlss: []
    };

    constructor(props) {
        super(props);

        this.state = {
            datiSegnalazione: {
                dataSegnalazione: Utils.formatDateISO(
                    this.props.segnalazioneCopia?.dataSegnalazione,
                    "/"
                ),
                regione: { codice: "", descrizione: "Veneto" },
                ulss: this.props.segnalazioneCopia?.ulssSegnalazione || "",
                corretto: []
            },
            regioni: JSON.parse(sessionStorage.getItem("regioni")) || [],
            listaUlss: Utils.getArrayUlss() || []
        };

        this.riceviValore = this.riceviValore.bind(this);
        this.aggiornaPadre = this.aggiornaPadre.bind(this);
    }

    componentDidMount() {
        this.aggiornaPadre();
    }

    riceviValore(field, value) {
        const newValue = value && value.target ? value.target.value : value;

        this.setState(prevState => {
            const nuovo = {
                ...prevState.datiSegnalazione,
                [field]: newValue
            };

            return {
                datiSegnalazione: {
                    ...nuovo,
                    corretto: this.controlloCorrettezza(nuovo)
                }
            };
        }, this.aggiornaPadre);
    }

    controlloCorrettezza(dati) {
        const corretto = [];

        if (!dati.dataSegnalazione) {
            corretto[0] = "Data segnalazione obbligatoria";
        }

        if (!dati.regione) {
            corretto[1] = "Regione obbligatoria";
        }

        if (!dati.ulss) {
            corretto[2] = "ULSS obbligatoria";
        }

        return corretto;
    }

    aggiornaPadre() {
        let copia = JSON.parse(JSON.stringify(this.state.datiSegnalazione));

        if (copia.regione && copia.regione.codice) {
            copia.regione = copia.regione.codice;
        }
        let oggettoBE = Utils.removeEmptyValueFromObject(copia);
        let oggettoBESenzaCorretto = Utils.removeFieldFromObject(copia, "corretto");

        if (this.props.setDatiSegnalazione) {
            this.props.setDatiSegnalazione(
                this.state.datiSegnalazione,
                oggettoBESenzaCorretto
            );
        }
    }

    render() {
        const { t } = this.props;
        const { datiSegnalazione, regioni, listaUlss } = this.state;

        return (
            <div className={"container"}>
                <div style={{marginTop: "10px"}}/>
                <div className="row mb-3 align-items-center">
                    <div className="col-lg-4">
                        <label style={{ fontWeight: "bold", color: "#000" }}>
                            {t("DatiSegnalazioneAnagrafici.data_segnalazione")} <span style={{ color: "red" }}>*</span>
                        </label>
                    </div>
                    <div className="col-lg-4">
                        <Calendar
                            id="dataSegnalazione"
                            field="dataSegnalazione"
                            value={datiSegnalazione.dataSegnalazione || ""}
                            onChange={this.riceviValore}
                            newCalendar={true}
                        />
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <div className="col-lg-4">
                        <label style={{ fontWeight: "bold", color: "#000" }}>
                            {t("DatiSegnalazioneAnagrafici.regione")} <span style={{ color: "red" }}>*</span>
                        </label>
                    </div>
                    <div className="col-lg-4">
                        <Autocomplete
                            id="idRegione"
                            field="regione"
                            value={datiSegnalazione.regione || ""}
                            keyField="codice"
                            descriptionField="descrizione"
                            suggestionField="descrizione"
                            suggestions={regioni}
                            onChange={this.riceviValore}
                            disabled={true}
                        />
                    </div>
                </div>

                <div className="row mb-3 align-items-center">
                    <div className="col-lg-4">
                        <label style={{ fontWeight: "bold", color: "#000" }}>
                            {t("DatiSegnalazioneAnagrafici.ulss")} <span style={{ color: "red" }}>*</span>
                        </label>
                    </div>
                    <div className="col-lg-4">
                        <SelectAutocomplete
                            id="idUlss"
                            field="ulss"
                            value={datiSegnalazione.ulss || ""}
                            onChange={this.riceviValore}
                            newSelect={true}
                            functionMap={listaUlss.map((oggetto) => (
                                <option key={oggetto.codice} value={oggetto.codice}>
                                    {oggetto.descrizione}
                                </option>
                            ))}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
export default withTranslation('common')(DatiSegnalazione)

